import { getEssentialsSeatLimits, getGuidsToSkip, getSubscriptionTier, getSubscriptionType, isEssentialsEditionPlanEnabled, SubscriptionType, UserState, } from '@thoughtspot/session-service';
import _ from 'lodash';
import { create } from './logger';
const logger = create('user-limit');
const seatUsageCache = new Map();
const getEssentialsTierUserLimits = () => {
    const limits = {};
    getEssentialsSeatLimits()
        .split(',')
        .forEach(pair => {
        const [tier, rawSeats] = pair.split('=').map(part => part.trim());
        const seats = Number(rawSeats);
        if (tier && Number.isInteger(seats) && seats > 0) {
            limits[tier] = seats;
        }
    });
    return limits;
};
export const getEssentialsPlanUserLimit = () => {
    if (!isEssentialsEditionPlanEnabled() ||
        getSubscriptionType() !== SubscriptionType.ESSENTIALS_EDITION) {
        return null;
    }
    return getEssentialsTierUserLimits()[getSubscriptionTier()] ?? null;
};
export const isUserLimitReached = (usage, limit) => !!usage && limit !== null && usage.totalUsers >= limit;
const SEAT_LIMIT_ERROR_CODES = ['13175', '13176'];
export const isSeatLimitError = (errorCode) => SEAT_LIMIT_ERROR_CODES.includes(errorCode);
const toSeatUsage = (users) => {
    const skippedIds = new Set(getGuidsToSkip());
    const seatedUsers = _.compact(users).filter(user => !skippedIds.has(user.id));
    const countByStatus = _.countBy(seatedUsers, 'account_status');
    return {
        totalUsers: seatedUsers.length,
        activeUsers: countByStatus[UserState.ACTIVE] ?? 0,
        pendingUsers: (countByStatus[UserState.PENDING] ?? 0) +
            (countByStatus[UserState.INACTIVE] ?? 0),
    };
};
export const readSeatUsage = (orgIdentifiers, searchUsers) => searchUsers({
    org_identifiers: orgIdentifiers,
    record_size: _.max(Object.values(getEssentialsTierUserLimits())),
    sort_options: { field_name: 'CREATED', order: 'DESC' },
}).then(users => (users ? toSeatUsage(users) : null), (error) => {
    logger.warn('Seat usage read failed', error);
    return null;
});
export const getCachedSeatUsage = (orgIdentifiers, searchUsers) => {
    const key = JSON.stringify(orgIdentifiers ?? null);
    const cached = seatUsageCache.get(key);
    if (cached) {
        return cached;
    }
    const usage = readSeatUsage(orgIdentifiers, searchUsers).then(result => {
        if (!result && seatUsageCache.get(key) === usage) {
            seatUsageCache.delete(key);
        }
        return result;
    });
    seatUsageCache.set(key, usage);
    return usage;
};
export const clearSeatUsageCache = () => {
    seatUsageCache.clear();
};
//# sourceMappingURL=user-limit.util.js.map